import { render } from "./LGPD.vue?vue&type=template&id=1669ad1f&scoped=true"
import script from "./LGPD.vue?vue&type=script&lang=js"
export * from "./LGPD.vue?vue&type=script&lang=js"

import "./LGPD.vue?vue&type=style&index=0&id=1669ad1f&scoped=true&lang=css"

import exportComponent from "/var/www/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1669ad1f"]])

export default __exports__